import { BordOneToneIcon } from 'bord-design-system';
import { Link } from 'react-router-dom';
import { bordColorTheme } from 'styles/styles.constants';
import { ILastQuote } from 'types/quoteEditor.types';
import { formatShortDate } from 'utils/formatDatesAndHours';
import { formatQuotePrice } from 'views/Quote/utils/formatQuotePrice';
import './LastQuotes.scss';

interface ILastQuotes {
  lastQuotes: ILastQuote[];
  country: string;
  isLoading?: boolean;
}

const COLUMN_HEADERS = ['N° de cotización', 'Fecha de cotización', 'Costo sin IVA', 'Precio final', 'Proveedor', 'Cliente'];

/** Ruta del detalle de cotización para abrir en nueva pestaña. */
const getQuoteDetailsPath = (quoteId: number): string => `/quote/details/${quoteId}`;

/**
 * Tabla de últimas cotizaciones históricas de un SKU en el país de la cotización activa.
 * No renderiza nada si no hay datos y no está cargando.
 */
const LastQuotes = ({ lastQuotes, country, isLoading }: ILastQuotes) => {
  if (!isLoading && !lastQuotes.length) return null;

  if (isLoading) {
    return <div className="lastQuotesSkeleton animationLoader" />;
  }

  return (
    <div className="lastQuotes">
      <div className="lastQuotesHeader">
        <BordOneToneIcon variant="clock" standardSize={14} stroke="#6F737D" />
        <span className="lastQuotesTitle">Últimas cotizaciones en {country}</span>
      </div>
      <div className="lastQuotesTableWrapper">
        <table className="lastQuotesTable">
          <thead>
            <tr>
              {COLUMN_HEADERS.map(header => (
                <th key={header}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {lastQuotes.map(quote => (
              <tr key={quote.quoteId}>
                <td>
                  <Link
                    className="lastQuotesQuoteLink"
                    to={getQuoteDetailsPath(quote.quoteId)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {`Q°${quote.quoteId}`}
                    <BordOneToneIcon variant="externalLink" standardSize={12} stroke={bordColorTheme.cyan[400]} />
                  </Link>
                </td>
                <td>{formatShortDate(quote.quoteCreatedAt).onlyDate ?? '—'}</td>
                <td>{formatQuotePrice(quote.cost, quote.currency)}</td>
                <td>{formatQuotePrice(quote.salePrice, quote.saleCurrency ?? quote.currency)}</td>
                <td>{quote.providerName ?? '—'}</td>
                <td>{quote.organizationName ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LastQuotes;
